import { useEffect } from 'react';
import { useLatestRef } from './useLatestRef';

export function useOnMount(cb: () => void, opts?: { delayMs?: number }) {
  const ref = useLatestRef(cb);
  useEffect(() => {
    if (opts?.delayMs !== undefined && opts.delayMs > 0) {
      const timeoutId = setTimeout(() => {
        ref.current();
      }, opts.delayMs);
      return () => clearTimeout(timeoutId);
    } else {
      ref.current();
    }
  }, []);
}
